import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {COLLECTION_STREAMS, KF_CATEGORIES, UNU_KEYS} from '../../../constants/constants';
import {Master} from '../../../admin/models/master.interface';
import {Page} from '../../../shared/models/page.interface';
import {ClassifiersService} from '../../services/classifiers.service';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {ClassifiersSearch} from '../../models/classifiers-search.interface';
import {MessageService} from '../../../shared/services/message.service';
import {ClassifierEditEvent} from '../../models/classifier-edit-event.interface';

@Component({
  selector: 'app-classifiers',
  templateUrl: './classifiers.component.html',
  styleUrls: ['./classifiers.component.scss']
})
export class ClassifiersComponent implements OnInit {


  origin = this.router.getCurrentNavigation()?.extras?.state?.origin;
  originStep = this.router.getCurrentNavigation()?.extras?.state?.wizardStep;

  currentRoute?: string;
  classifiersType!: string;
  classifiersPage!: Page<Master>;
  private pageRequest: PageRequest = {page: 0, size: 100, sort: 'code', direction: 'asc'};
  private classifiersSearch: ClassifiersSearch = {status: 'ACTIVE'};

  constructor(private router: Router,
              private classifiersService: ClassifiersService,
              private activatedRoute: ActivatedRoute,
              private messageService: MessageService) {
    this.currentRoute = router.getCurrentNavigation()?.extractedUrl.toString();
  }

  ngOnInit(): void {
    this.classifiersType = this.getClassifiersType();
    this.activatedRoute.queryParams.subscribe(params => {
      if (params.code) {
        this.classifiersSearch.code = params.code;
      }
      if (params.description) {
        this.classifiersSearch.description = params.description;
      }
      if (params.status) {
        this.classifiersSearch.status = params.status;
      }
    });
    this.classifiersService.search(this.classifiersType, this.pageRequest, this.classifiersSearch)
      .subscribe(data => this.classifiersPage = data);
  }

  getClassifiersType = () => {
    if (this.currentRoute?.includes(COLLECTION_STREAMS)) {
      return COLLECTION_STREAMS;
    } else if (this.currentRoute?.includes(KF_CATEGORIES)) {
      return KF_CATEGORIES;
    } else {
      return UNU_KEYS;
    }
  }

  loadClassifiers(event: PageRequest): void {
    this.classifiersService.search(this.classifiersType, event)
      .subscribe(data => {
        this.classifiersPage = data;
        this.pageRequest = event;
      });
  }

  search(event: ClassifiersSearch): void {
    this.classifiersService.search(this.classifiersType, this.pageRequest, event)
      .subscribe(data => {
        this.classifiersPage = data;
        this.classifiersSearch = event;
        const queryParams = {};
        if (event.code && event.code !== '') {
          Object.assign(queryParams, {code: event.code});
        }
        if (event.description && event.description !== '') {
          Object.assign(queryParams, {description: event.description});
        }
        if (event.status && event.status !== '') {
          Object.assign(queryParams, {status: event.status});
        }
        this.router.navigate([this.router.url.split('?')[0]], {queryParams});

      });
  }

  create(event: ClassifierEditEvent): void {
    this.classifiersService.create(event.classifier, this.classifiersType)
      .subscribe(() => {
        this.search(this.classifiersSearch);
        this.messageService.showMessage('The item has been successfully added', 'success');
        if (event.dialogRef) {
          event.dialogRef.close();
        }
      });
  }

  update(event: ClassifierEditEvent): void {
    this.classifiersService.update(event.classifier, this.classifiersType)
      .subscribe(() => {
        this.search(this.classifiersSearch);
        this.messageService.showMessage('Changes have been saved correctly', 'success');
        if (event.dialogRef) {
          event.dialogRef.close();
        }
      });
  }

  delete(id: number): void {
    this.classifiersService.delete(id, this.classifiersType)
      .subscribe(() => {
        this.search(this.classifiersSearch);
        this.messageService.showMessage('The item has been successfully deleted', 'success');
      });
  }

}
